import React from "react";
import {
    Modal,
    Space,
    Button,
    Form,
    useModalForm,
    Input,
} from "@pankod/refine-antd";

const { TextArea } = Input;

export const RejectTransBnkRequestModal: React.FC<{ bankUserAuthorizationRequestId: string, refetchTableProps: any }> = ({ bankUserAuthorizationRequestId, refetchTableProps }) => {
    const {
        modalProps: rejectTransBnkRequestModal,
        formProps: rejectTransBnkRequestForm,
        show: rejectTransBnkRequestShow,
        close: rejectTransBnkRequestClose
    } = useModalForm({
        action: "create",
        dataProviderName: "grapghQl",
        resource: "rejectCorporateOnboardingRequestForConnectedBanking",
        metaData: {
            bankUserAuthorizationRequestId,
        },
        redirect: false,
        onMutationSuccess() {
            rejectTransBnkRequestClose();
            refetchTableProps(false);
        }
    });

    rejectTransBnkRequestModal.title = 'Reject TransBnk Request';
    rejectTransBnkRequestModal.confirmLoading = true;
    rejectTransBnkRequestModal.centered = true;
    rejectTransBnkRequestModal.width = 500;
    rejectTransBnkRequestModal.onCancel = () => {
        rejectTransBnkRequestForm.form?.resetFields();
        rejectTransBnkRequestClose();
    };

    return (
        <Space >
            <Button danger={true} onClick={() => { rejectTransBnkRequestShow() }}  >
                Reject
            </Button>

            <Modal {...rejectTransBnkRequestModal}>
                <Form {...rejectTransBnkRequestForm} layout="vertical">
                    <Form.Item
                        rules={[
                            {
                                required: true,
                            }
                        ]}
                        label="Last Update Notes"
                        name="lastUpdateNotes"
                    >
                        <TextArea rows={4} placeholder="Last Update Notes" onChange={(event: any) => {
                            (event?.target?.value.trim()) ?
                                rejectTransBnkRequestForm.form?.setFieldsValue({ lastUpdateNotes: event?.target?.value }) :
                                rejectTransBnkRequestForm.form?.setFieldsValue({ lastUpdateNotes: event?.target?.value.trim() })
                        }} />
                    </Form.Item>
                </Form>
            </Modal>
        </Space>
    );
};